var cov_6dr2bbwry = function () {
  var path = "/Users/spana/SHEIN/shineout/src/utils/classname.ts",
      hash = "64aa4092a9f1a0d6b49b978d3a4a6ee8d4eaf761",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/utils/classname.ts",
    statementMap: {
      "0": {
        start: {
          line: 9,
          column: 33
        },
        end: {
          line: 9,
          column: 86
        }
      },
      "1": {
        start: {
          line: 9,
          column: 48
        },
        end: {
          line: 9,
          column: 86
        }
      },
      "2": {
        start: {
          line: 17,
          column: 85
        },
        end: {
          line: 27,
          column: 1
        }
      },
      "3": {
        start: {
          line: 18,
          column: 20
        },
        end: {
          line: 18,
          column: 39
        }
      },
      "4": {
        start: {
          line: 19,
          column: 2
        },
        end: {
          line: 19,
          column: 27
        }
      },
      "5": {
        start: {
          line: 19,
          column: 18
        },
        end: {
          line: 19,
          column: 27
        }
      },
      "6": {
        start: {
          line: 21,
          column: 13
        },
        end: {
          line: 21,
          column: 54
        }
      },
      "7": {
        start: {
          line: 22,
          column: 34
        },
        end: {
          line: 22,
          column: 96
        }
      },
      "8": {
        start: {
          line: 22,
          column: 65
        },
        end: {
          line: 22,
          column: 94
        }
      },
      "9": {
        start: {
          line: 23,
          column: 2
        },
        end: {
          line: 25,
          column: 3
        }
      },
      "10": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 24,
          column: 62
        }
      },
      "11": {
        start: {
          line: 24,
          column: 48
        },
        end: {
          line: 24,
          column: 61
        }
      },
      "12": {
        start: {
          line: 26,
          column: 2
        },
        end: {
          line: 26,
          column: 23
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 9,
            column: 33
          },
          end: {
            line: 9,
            column: 34
          }
        },
        loc: {
          start: {
            line: 9,
            column: 48
          },
          end: {
            line: 9,
            column: 86
          }
        },
        line: 9
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 17,
            column: 15
          },
          end: {
            line: 17,
            column: 16
          }
        },
        loc: {
          start: {
            line: 17,
            column: 85
          },
          end: {
            line: 27,
            column: 1
          }
        },
        line: 17
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 17,
            column: 85
          },
          end: {
            line: 17,
            column: 86
          }
        },
        loc: {
          start: {
            line: 17,
            column: 103
          },
          end: {
            line: 27,
            column: 1
          }
        },
        line: 17
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 22,
            column: 59
          },
          end: {
            line: 22,
            column: 60
          }
        },
        loc: {
          start: {
            line: 22,
            column: 65
          },
          end: {
            line: 22,
            column: 94
          }
        },
        line: 22
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 24,
            column: 20
          },
          end: {
            line: 24,
            column: 21
          }
        },
        loc: {
          start: {
            line: 24,
            column: 48
          },
          end: {
            line: 24,
            column: 61
          }
        },
        line: 24
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 9,
            column: 61
          },
          end: {
            line: 9,
            column: 84
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 9,
            column: 71
          },
          end: {
            line: 9,
            column: 76
          }
        }, {
          start: {
            line: 9,
            column: 79
          },
          end: {
            line: 9,
            column: 84
          }
        }],
        line: 9
      },
      "1": {
        loc: {
          start: {
            line: 17,
            column: 50
          },
          end: {
            line: 17,
            column: 80
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 17,
            column: 67
          },
          end: {
            line: 17,
            column: 80
          }
        }],
        line: 17
      },
      "2": {
        loc: {
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 19,
            column: 27
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 19,
            column: 27
          }
        }, {
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 19,
            column: 27
          }
        }],
        line: 19
      },
      "3": {
        loc: {
          start: {
            line: 21,
            column: 25
          },
          end: {
            line: 21,
            column: 52
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 21,
            column: 34
          },
          end: {
            line: 21,
            column: 46
          }
        }, {
          start: {
            line: 21,
            column: 49
          },
          end: {
            line: 21,
            column: 52
          }
        }],
        line: 21
      },
      "4": {
        loc: {
          start: {
            line: 22,
            column: 65
          },
          end: {
            line: 22,
            column: 94
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 22,
            column: 77
          },
          end: {
            line: 22,
            column: 79
          }
        }, {
          start: {
            line: 22,
            column: 82
          },
          end: {
            line: 22,
            column: 94
          }
        }],
        line: 22
      },
      "5": {
        loc: {
          start: {
            line: 23,
            column: 2
          },
          end: {
            line: 25,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 23,
            column: 2
          },
          end: {
            line: 25,
            column: 3
          }
        }, {
          start: {
            line: 23,
            column: 2
          },
          end: {
            line: 25,
            column: 3
          }
        }],
        line: 23
      },
      "6": {
        loc: {
          start: {
            line: 24,
            column: 48
          },
          end: {
            line: 24,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 24,
            column: 48
          },
          end: {
            line: 24,
            column: 56
          }
        }, {
          start: {
            line: 24,
            column: 60
          },
          end: {
            line: 24,
            column: 61
          }
        }],
        line: 24
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import classnames from 'classnames';
import config, { isRTL } from '../config';
cov_6dr2bbwry.s[0]++;
export var getDirectionClass = function getDirectionClass(c) {
  cov_6dr2bbwry.f[0]++;
  cov_6dr2bbwry.s[1]++;
  return "".concat(c, " ").concat(c, "-").concat(isRTL() ? (cov_6dr2bbwry.b[0][0]++, 'rtl') : (cov_6dr2bbwry.b[0][1]++, 'ltr'));
};
/**
 * create a new className generate function, add namespace, handle css module
 * @param style - object; for css module
 * @param module - string
 * @param prefix - string, default value is 'shineout'
 * * */

export default (function (style, module) {
  var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (cov_6dr2bbwry.b[1][0]++, config.prefix);
  cov_6dr2bbwry.f[1]++;
  cov_6dr2bbwry.s[2]++;
  return function () {
    cov_6dr2bbwry.f[2]++;
    var className = (cov_6dr2bbwry.s[3]++, classnames.apply(void 0, arguments));
    cov_6dr2bbwry.s[4]++;

    if (!className) {
      cov_6dr2bbwry.b[2][0]++;
      cov_6dr2bbwry.s[5]++;
      return '';
    } else {
      cov_6dr2bbwry.b[2][1]++;
    }

    var ns = (cov_6dr2bbwry.s[6]++, "".concat(prefix).concat(module ? (cov_6dr2bbwry.b[3][0]++, "-".concat(module)) : (cov_6dr2bbwry.b[3][1]++, '-')));
    var list = (cov_6dr2bbwry.s[7]++, className.split(' ').map(function (c) {
      cov_6dr2bbwry.f[3]++;
      cov_6dr2bbwry.s[8]++;
      return c === '_' ? (cov_6dr2bbwry.b[4][0]++, ns) : (cov_6dr2bbwry.b[4][1]++, "".concat(ns, "-").concat(c));
    }));
    cov_6dr2bbwry.s[9]++;

    if (config.cssModule) {
      cov_6dr2bbwry.b[5][0]++;
      cov_6dr2bbwry.s[10]++;
      list = list.map(function (c) {
        cov_6dr2bbwry.f[4]++;
        cov_6dr2bbwry.s[11]++;
        return (cov_6dr2bbwry.b[6][0]++, style[c]) || (cov_6dr2bbwry.b[6][1]++, c);
      });
    } else {
      cov_6dr2bbwry.b[5][1]++;
    }

    cov_6dr2bbwry.s[12]++;
    return list.join(' ');
  };
});